/**
 * @file  src\mobile\components\ReportWantAdModal.js
 * @brief  This file is responsible for reason for report want ad modal
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { getWantAdReportingReasons } from "../../services/commonServices";
import { USER_INFO_KEY } from "../../constants/common";
import { getLocalStorage } from "../../helpers/common";
import { reportWantAd } from "../../services/wantAdService";
import { toast } from "react-toastify";

const ReportWantAdModal = (props) => {
  const { show, onHide, wantAdId } = props;
  const [reportReasons, setReportReasons] = useState([]);
  const [selectedReason, setSelectedReason] = useState(null);
  const sessionData = getLocalStorage(USER_INFO_KEY);
  const userId = _.get(sessionData, "userInfo.userId", "");

  useEffect(() => {
    fetchReportingReasons();
  }, []);
  /**
   * To fetch want ad reporting reasons
   */
  const fetchReportingReasons = async () => {
    await getWantAdReportingReasons().then((response) => {
      if (response?.errorCode === 0) {
        setReportReasons(response?.result);
      } else {
        setReportReasons([]);
      }
    });
  };
  /**
   * To handle report want ad
   */
  const handleReportWantAd = async () => {
    const params = {
      userId: userId,
      wantAdId: wantAdId,
      reasonId: selectedReason,
    };

    await reportWantAd(params)
      .then((response) => {
        props.onHide();
        if (response?.errorCode === 0) {
          toast.dismiss();
          setSelectedReason(null);
          toast.success("Report was successfully submitted");
        } else {
          toast.dismiss();
          setSelectedReason(null);
          toast.error(response?.message);
        }
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(err);
      });
  };

  const handleCancel = () => {
    setSelectedReason(null);
    props.onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="modalPopupstyle delete-popup"
      {...props}
    >
      <Modal.Body>
        <div className="text-center mb-3">
          <h3>Report this want-listing</h3>
          <p>
            Your report is always anonymous. Once the report is made we’ll
            investigate the situation and determine what to do next.
          </p>
        </div>
        <p className="modal-small-heading">Reason for reporting:</p>
        <div className="modal-controls-wrap mb-32">
          {reportReasons.length > 0 &&
            reportReasons.map((reason) => {
              return (
                <label className="radio-wrap mb-3 ">
                  <input
                    type="radio"
                    name="radio-ad-option"
                    onChange={() => {
                      setSelectedReason(reason?.ReasonId);
                    }}
                    checked={reason?.ReasonId === selectedReason}
                  />
                  <span className="mob-radio-span">{reason?.Reason_Text}</span>
                </label>
              );
            })}
        </div>

        <div></div>

        <div className="btn-wrap">
          <button
            type="button"
            className="btn btn-primary w-100"
            disabled={selectedReason === null}
            onClick={() => handleReportWantAd()}
          >
            Report Want-Listing
          </button>
          <button
            type="button"
            className="btn btn-secondary w-100"
            onClick={handleCancel}
          >
            Cancel
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default ReportWantAdModal;
